import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { DatasourcesDisplayGridRowDataFragment } from '../../../gen-src/queries/DatasourcesDisplayGridRowDataFragment';
import { LensUpstreamDatasourcesQuery, LensUpstreamDatasourcesQueryVariables } from '../../../gen-src/queries/LensUpstreamDatasourcesQuery';
import { PublishedDatasourceSortOrder } from '../../../gen-src/queries/globalTypes';
import { LensUpstreamDatasourcesQueryGql } from '../../queries/LensUpstreamDatasourcesQueryGql';
import { DatasourcesDisplayGrid, DatasourcesDisplayGridRowData, getRowDataForDatasource } from '../sharedDisplayGrid/DatasourcesDisplayGrid';
import { DatasourcesValidSortFields } from '../sorting/sortProviders/DatasourcesGridSortProvider';

type QueryVariables = LensUpstreamDatasourcesQueryVariables;
type QueryResults = LensUpstreamDatasourcesQuery;
type QueryResultListNode = DatasourcesDisplayGridRowDataFragment;
type GridRowData = DatasourcesDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses && resultData.lenses[0]?.upstreamDatasourcesConnection;
}

export type LensUpstreamDatasourcesQueryGridProps =
  GridSortProps<DatasourcesValidSortFields> & Readonly<{
    vizportalUrlId: string;
    rowCount: number | null;
  }>;

export const LensUpstreamDatasourcesQueryGrid: React.FC<LensUpstreamDatasourcesQueryGridProps> = props => {
  const emptyGridMessage = Messages.EmptyUpstreamDatasourcesLineageGridMessage();
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={LensUpstreamDatasourcesQueryGql}
      partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as PublishedDatasourceSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForDatasource}
    >
      {({ rowStore }) =>
        <DatasourcesDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
}
